import { Component, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import { UserService } from "../../../../auth/service";

@Component({
  selector: "app-widget-future-employees",
  templateUrl: "./widget-future-employees.component.html",
  styleUrls: ["./widget-future-employees.component.scss"],
})
export class WidgetFutureEmployeesComponent implements OnInit {
  public futureEmployees: any = [];

  constructor(
    private _userService: UserService,
    public _utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    this.futureEmployees = await this._userService.getFutureEmployees();
    this.futureEmployees = this.futureEmployees.sort((a: any, b: any) => b.start_date - a.start_date);
    this.futureEmployees = this.futureEmployees.slice(0, 5);
  }
}
